<template>
  <v-container fluid ma-0 pa-0 px-4 >
    <Loading :isLoading="loading">
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Import
                </h2>
              </template>
                <span>Import</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Import data into {{caseType.displayName}} cases</h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
      <v-flex xs12 pt-3>
            <v-flex xs12>
              <!-- STEP 1 -->
              <h3 class="pb-2 mr-2 d-inline-block">
                <span class="mr-1" style="font-weight: 700;">Step 1</span>
                - What type of data are you importing?
              </h3>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="secondary"
                    class="d-inline-block"
                    dark
                    v-on="on">help
                  </v-icon>
                </template>
                <span>Tooltip</span>
              </v-tooltip>
              <v-flex xs12 px-4 py-3 mb-4 class="white-bg elevation-2 rounded-3">
                <v-flex xs12>
                  <v-radio-group class="mt-1" v-model="dataTypeSelected" mandatory>
                    <v-radio color="secondary" label="Atomic Data" value="atomicSelected"></v-radio>
                    <v-radio color="secondary" label="Tabular Data" value="tabularSelected"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-flex>
              <!-- STEP 2 + -->
              <tabular-import
                v-if="dataTypeSelected === 'tabularSelected'"
                v-on:update-import-data="updateImportData"
                v-on:ready-to-upload="setReadyToUpload">
              </tabular-import>
              <atomic-import
                v-if="dataTypeSelected === 'atomicSelected'"
                v-on:update-import-data="updateImportData"
                v-on:ready-to-upload="setReadyToUpload">
                </atomic-import>
              <!-- Final 3 Steps -->
              <upload-import
                v-if="readyToUpload"
                :dataType="dataTypeSelected"
                :selections="importData">
              </upload-import>
            </v-flex>
      </v-flex>
    </Loading>
  </v-container>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"
import TabularImport from "@/components/import/TabularImport.vue"
import AtomicImport from "@/components/import/AtomicImport.vue"
import UploadImport from "@/components/import/UploadImport.vue"
import { mapState } from "vuex"

export default {
  name: "import-wizard",
  components: { Loading, TabularImport, AtomicImport, UploadImport },
  data: () => {
    return {
      dataTypeSelected: "",
      loading: false,
      readyToUpload: false,
      importData: {}
    }
  },
  computed: {
    ...mapState({
      caseType: state => state.caseTypes.current
    })
  },
  watch: {
    dataTypeSelected() {
      this.importData = {}
      this.readyToUpload = false
    }
  },
  methods: {
    setReadyToUpload(state) {
      this.readyToUpload = state
    },
    updateImportData(data) {
      this.importData[data.name] = data.value
    }
  }
}
</script>

<style>
.cvs-column-guide {
  overflow: scroll;
  width: 100%;
}

.cvs-column-guide th {
  background: #dbdbdb;
  padding: 10px 20px;
  line-height: 1.2em;
  white-space: nowrap;
  color: #1c1c2d;
}

.cvs-column-guide td {
  background: #ffffff;
  padding: 10px 20px;
  line-height: 1.2em;
  white-space: nowrap;
  color: #1c1c2d;
}
</style>
